import React, { memo } from 'react'

import { func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function UploadPrompt({ onBrowseClick }) {
  const t = useTranslation()

  return (
    <>
      <span className="image-uploader__title">
        {t('shared.actionSelector.imageUploader.uploadPrompt.dropHere')}{' '}
        <a className="cgt-legacy-link image-uploader__link" onClick={onBrowseClick}>
          {t('shared.actionSelector.imageUploader.uploadPrompt.browse')}
        </a>
      </span>
      <span className="image-uploader__subtitle">
        {t('shared.actionSelector.imageUploader.uploadPrompt.fileTypes')}
      </span>
    </>
  )
}

UploadPrompt.propTypes = {
  onBrowseClick: func.isRequired,
}

export default memo(UploadPrompt)
